export default {

  //заполнить данные по городам
  loadCities(state, data){
    state.items=data;
  },

  //обновить город
  editCity(state, editdata){
    var ind= state.items.findIndex(x=>x.id==editdata.id)
    if(ind!=-1&&ind!=undefined){
        state.items.splice(ind,1,editdata);
      }
  },

  //добавить город
  addCity(state, newdata){
      state.items.push(newdata)
  },

  //удалить город
  deleteCity(state, cityId){
    var ind= state.items.findIndex(x=>x.id==cityId)
    if(ind!=-1&&ind!=undefined){
        state.items.splice(ind,1);
    }
  },
}
